import { useCallback, useState } from "react";
import { CatalogBuilder } from "../../../../commonGroupModuleStructure/catalogBuilder";
import { MuiRightDrawer } from "../../../../components";
import CheckListSearch from "../../../../components/CheckListSearch";
import { createMenuRoleMapping, deleteMenuRoleMapping, getMenuNotInRoles, getMenuRoleMapping } from "../apiCall";
import { MenuKeys } from "../entity";
import { APIParams } from "../../role/apiCall";
import { useAppSelector } from "../../../../store/hooks";

export const MenuRoleMapping = (props: any) => {
  const { request } = props;
  const crud = useAppSelector(state => state.crud);
  const [open, setOpen] = useState(false);
  const name = "Modules";

  const onClickPlus = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const getOptions = useCallback(async (params: APIParams) =>
    await getMenuNotInRoles({ ...params, request: { ...params.request, ...request } })
    , [request])

  const onSubmit = useCallback(async (params: APIParams) => {
    if (!params.request) return;
    let arr = params.request[name];
    arr = arr?.map((val: any) => ({
      ModuleId: crud[MenuKeys.get]?.data?.ModuleId,
      RoleId: val
    }));

    params.request[name] = arr;

    return await createMenuRoleMapping({
      ...params,
      request: { ...params.request, ...request }
    })
  }, [request, crud[MenuKeys.get]?.data?.ModuleId])

  return (
    <>
      <CatalogBuilder
        isHeader={false}
        isAssociationButton={true}
        isRightMenu={true}

        getPagingData={getMenuRoleMapping}
        pagingAPIrequest={request}
        pagingAPIKey={MenuKeys.getRoles}

        onDelete={deleteMenuRoleMapping}
        deletePagingAPIKey={MenuKeys.deleteRoles}

        onClickPlus={onClickPlus}
        // pagingColumns={columns}
        visibleColumns={{
          MenuName: false,
          DisplayName: false,
        }}
        disableEditAction={true}
        disableViewAction={true}
      />
      <MuiRightDrawer open={open} onClose={onClose} width='40%'>
        <CheckListSearch
          getOptions={getOptions}
          displayExpr={'DisplayName'}
          listKey={MenuKeys.notInRoles}
          label='Add Roles'
          name='Modules'
          onSubmit={onSubmit}
          onClose={onClose}
          pagingAPIKey={MenuKeys.getRoles}
        />
      </MuiRightDrawer>
    </>
  );
};
